import { ITimecard, TimeCardLine } from '../../interface/ISelectedDate'

export function updateBreakLines(
    selectedDate: ITimecard,
    noBreaks: TimeCardLine[] | undefined,
    breaksCopy: TimeCardLine[],
    dispatch: (action: any) => void,
    setSelectedDate: (date: ITimecard) => any
) {
    const newTimeCardLines: TimeCardLine[] | undefined = selectedDate?.lines
    if (newTimeCardLines && noBreaks) {
        const newTimeCardLinesCopy = [...noBreaks, ...breaksCopy]
        const newSelectedDate = JSON.parse(JSON.stringify(selectedDate))
        if (newSelectedDate?.lines) {
            newSelectedDate.lines = newTimeCardLinesCopy
        }
        dispatch(setSelectedDate(newSelectedDate))
    }
}